/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PassengerSummary
 */
export interface PassengerSummary {
    /**
     * 
     * @type {string}
     * @memberof PassengerSummary
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PassengerSummary
     */
    lastName?: string;
}

/**
 * Check if a given object implements the PassengerSummary interface.
 */
export function instanceOfPassengerSummary(value: object): value is PassengerSummary {
    return true;
}

export function PassengerSummaryFromJSON(json: any): PassengerSummary {
    return PassengerSummaryFromJSONTyped(json, false);
}

export function PassengerSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PassengerSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function PassengerSummaryToJSON(json: any): PassengerSummary {
    return PassengerSummaryToJSONTyped(json, false);
}

export function PassengerSummaryToJSONTyped(value?: PassengerSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['firstName'],
        'last_name': value['lastName'],
    };
}

